import React from 'react'
import { SelectConditionName } from '../../constants/conditions'
import { ConditionName, Option, OptionSetType } from '../../actions'
import listenToClickOutside from 'react-onclickoutside'
import { formatCondition } from '../../utils'
import { AREA_STATES } from '../../constants/options'
import { css } from '@emotion/react'
import { colors } from 'plume-ui'
import { OptionDropdown } from '../../../../view/OptionDropdown'
import { IcomoonIcon } from '../../../../atoms/IcomoonIcon'

function isListItem(el: any) {
  const cls = el.getAttribute('class')
  return el.tagName === 'LI' && (cls === 'item' || cls === 'item is-selected')
}

const Button = ({ selected, onClick }: { selected: any; onClick: any }) => {
  if (selected.length > 0) {
    return (
      <span
        onClick={onClick}
        css={css`
          margin-left: 5px;
        `}
      >
        <i
          className="icomoon icon-close1 right"
          css={css`
            font-size: 10px;
            color: ${colors.white10};
            &:before {
              font-size: 0.65rem;
              margin-left: 5px;
            }
          `}
        />
      </span>
    )
  } else {
    return (
      <IcomoonIcon
        name="arrow8-down"
        css={css`
          font-size: 10px;
          color: ${colors.white10};
          &:before {
            font-size: 0.65rem;
            margin-left: 5px;
          }
        `}
      />
    )
  }
}

const DropdownItem = ({
  children,
  selected,
  onClick,
}: {
  children: any
  selected: any
  onClick: any
}) => {
  return (
    <li
      className={selected ? 'item is-selected' : 'item'}
      onClick={onClick}
      css={css`
        list-style: none;
        cursor: pointer;
        color: ${colors.gray90};
        line-height: 20px;
        padding: 3px 10px 4px 25px;
        :hover {
          background-color: #f1f1f1;
        }
      `}
    >
      <i
        className={selected && 'icomoon icon-check1'}
        css={css`
          cursor: pointer;
          display: inline-block;
          min-width: 2em;
          width: 13px;
          height: 13px;
          &:before {
            margin-left: 5px;
            color: ${colors.text};
          }
        `}
      />
      {children}
    </li>
  )
}

const GroupDropdownItem = ({
  children,
  selected,
  indeterminate = false,
  onLabelClick,
  onIconClick,
}: {
  children: any
  selected: any
  indeterminate?: boolean
  onLabelClick: any
  onIconClick: any
}) => {
  return (
    <div
      className="area-item"
      css={css`
        list-style: none;
        padding: 2px 0 !important;
      `}
    >
      <i
        className={
          selected ? 'is-selected icomoon icon-check1 area-icon' : 'area-icon'
        }
        onClick={() => {
          onIconClick()
        }}
        css={css`
          cursor: pointer;
          display: inline-block;
          min-width: 2em;
          width: 13px;
          height: 13px;
          &:before {
            margin-left: 5px;
            color: ${indeterminate ? colors.gray60 : colors.text};
          }
        `}
      ></i>
      <div
        onClick={onLabelClick}
        css={css`
          width: 100%;
          cursor: pointer;
          display: inline-block;
        `}
      >
        {children}
      </div>
    </div>
  )
}

const DropdownRow = ({
  values,
  selected,
  onClick,
}: {
  values: any
  selected: any
  onClick: any
}) => {
  return (
    <dd
      css={css`
        margin: 0;
        padding: 0;
      `}
    >
      {values.map((value: any, i: any) => {
        return (
          <DropdownItem
            key={`${i}`}
            selected={selected.includes(value)}
            onClick={() => onClick(value)}
          >
            {value}
          </DropdownItem>
        )
      })}
    </dd>
  )
}

class AreaList extends React.PureComponent<any, any> {
  isAllSelected() {
    const { selected, prefs } = this.props
    // ちょっと荒業だが文字列結合で検索する
    const sl = selected.join('')
    const includes = prefs.map((p: any) => sl.indexOf(p) > -1)
    return includes.every((i: any) => !!i)
  }
  isPartialSelected() {
    const { selected, prefs } = this.props
    // ちょっと荒業だが文字列結合で検索する
    const sl = selected.join('')
    const includes = prefs.map((p: any) => sl.indexOf(p) > -1)
    return includes.some((i: any) => !!i)
  }

  getAreaLabelSelected() {
    if (this.isAllSelected()) {
      return { selected: true, indeterminate: false }
    }

    if (this.isPartialSelected()) {
      return { selected: true, indeterminate: true }
    }
    return { selected: false }
  }
  handleIconClick = () => {
    if (this.isAllSelected()) {
      this.props.onIconClick(this.props.prefs, 'remove')
    } else {
      this.props.onIconClick(this.props.prefs, 'add')
    }
  }
  render() {
    const { label, prefs, expanded, selected, onLabelClick, onPrefClick } =
      this.props
    return (
      <dl
        css={css`
          margin: 0 !important;
          padding-left: 0;
        `}
      >
        <dt
          css={css`
            list-style: none;
            padding: 2px 0 !important;
            color: ${colors.gray90};
            line-height: 20px;
            :hover {
              background-color: #f1f1f1;
            }
          `}
        >
          <GroupDropdownItem
            onIconClick={this.handleIconClick}
            onLabelClick={onLabelClick}
            {...this.getAreaLabelSelected()}
          >
            {label}
          </GroupDropdownItem>
        </dt>
        {expanded && (
          <DropdownRow
            values={prefs}
            selected={selected}
            onClick={onPrefClick}
          />
        )}
      </dl>
    )
  }
}

type PrefectureConditionProps = {
  name: SelectConditionName
  open: boolean
  selected: string[]
  onToggle: (cond: ConditionName) => any
  onRemove: (param: ConditionName) => any
  onSelect: (cond: ConditionName, option: String) => any
  onSelectList: (
    cond: ConditionName,
    option: String,
    setType: OptionSetType
  ) => any
}

type State = {
  expands: any
}
export class PrefectureConditionInternal extends React.Component<
  PrefectureConditionProps,
  State
> {
  constructor(props: any) {
    super(props)
    this.state = {
      expands: {},
    }
  }
  handleSelect(option: Option) {
    this.props.onSelect(this.props.name, option)
  }

  handleToggle(target: EventTarget) {
    if (!isListItem(target)) {
      this.props.onToggle(this.props.name)
    }
  }

  handleClickOutside() {
    if (this.props.open) {
      this.props.onToggle(this.props.name)
    }
  }
  handleGroupLabelClick = (label: any) => {
    const newState = {
      expands: {
        ...this.state.expands,
        [label]: !this.state.expands[label],
      },
    }
    this.setState(newState)
  }
  handleGroupIconClick = (prefs: any, setType: any) => {
    this.props.onSelectList(this.props.name, prefs, setType)
  }
  render() {
    const { name, selected } = this.props
    const { expands } = this.state
    const { handleGroupLabelClick, handleGroupIconClick } = this
    return (
      <div
        className={'condition'}
        css={css`
          background-color: ${colors.cyan50};
          border-radius: 50px;
          color: ${colors.white10};
          display: inline-block;
          font-size: 13px;
          position: relative;
          &:last-child {
            margin-right: 5px;
          }
        `}
      >
        <li
          className="condition-label"
          onClick={(e) => this.handleToggle(e.target)}
          css={css`
            padding: 5px 10px 5px 15px;
            cursor: pointer;
          `}
        >
          <span>{formatCondition(name, selected)}</span>
          <Button
            selected={selected}
            onClick={() => this.props.onRemove(this.props.name)}
          />
        </li>
        <OptionDropdown open={this.props.open}>
          {AREA_STATES.map(({ label, prefs }, i) => {
            return (
              <AreaList
                key={i}
                label={label}
                prefs={prefs}
                selected={selected}
                onIconClick={(prefs: any, toogle: any) =>
                  handleGroupIconClick(prefs, toogle)
                }
                onLabelClick={() => handleGroupLabelClick(label)}
                expanded={expands[label]}
                onPrefClick={(e: any) => this.handleSelect(e)}
              />
            )
          })}
        </OptionDropdown>
      </div>
    )
  }
}

export default listenToClickOutside(PrefectureConditionInternal)
